import { API_BASE_URL, request } from './request';

export const ingestProduceSource = async (payload) => {
  const options = payload instanceof FormData
    ? { method: 'POST', body: payload }
    : { method: 'POST', body: JSON.stringify(payload || {}) };
  return request(`${API_BASE_URL}/produce/sources/ingest`, options);
};

export const getProduceSource = async (sourceId) => {
  const id = String(sourceId || '').trim();
  if (!id) throw new Error('sourceId is required');
  return request(`${API_BASE_URL}/produce/sources/${encodeURIComponent(id)}`);
};

export const reparseProduceSource = async (sourceId) => {
  const id = String(sourceId || '').trim();
  if (!id) throw new Error('sourceId is required');
  return request(`${API_BASE_URL}/produce/sources/${encodeURIComponent(id)}/reparse`, {
    method: 'POST',
  });
};

export const createProduceRun = async (payload = {}) => request(`${API_BASE_URL}/produce/runs/create`, {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const getProduceRun = async (runId) => {
  const id = String(runId || '').trim();
  if (!id) throw new Error('runId is required');
  return request(`${API_BASE_URL}/produce/runs/${encodeURIComponent(id)}`);
};

export const cancelProduceRun = async (runId) => {
  const id = String(runId || '').trim();
  if (!id) throw new Error('runId is required');
  return request(`${API_BASE_URL}/produce/runs/${encodeURIComponent(id)}/cancel`, {
    method: 'POST',
  });
};

export const listProduceRuns = async (payload = {}) => request(`${API_BASE_URL}/produce/runs/list`, {
  method: 'POST',
  body: JSON.stringify(payload),
});
